///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GtthProjectStateService } from '../logical-topology/engine/project-state.service';
import { ProjectMigrationInfoDto } from '../../generated/shared-types.model';
import { isDefined } from '@siklu/sui-lib/utils';

@Injectable()
export class ProjectMigrationStateService {
    private currentProjectMigrationState: ProjectMigrationInfoDto;

    constructor(
        private readonly http: HttpClient,
        private readonly projectStateService: GtthProjectStateService
    ) {
        this.currentProjectMigrationState = {
            migratedId: undefined,
            originId: undefined,
            originName: undefined,
            isMigrated: false,
            isShowMessage: false
        } as ProjectMigrationInfoDto;
    }

    public hasOriginProject(): boolean {
        return isDefined(this.currentProjectMigrationState.originId) && isDefined(this.currentProjectMigrationState.originName);
    }

    public getOriginProjectName(): string {
        return this.currentProjectMigrationState.originName;
    }

    public getOriginProjectUrl(): string {
        return `#/project-view/${this.currentProjectMigrationState.originId}`;
    }

    public loadAndHandleProjectMigrationState(): void {
        this.http.get<ProjectMigrationInfoDto>(`/api/project/migrated/${this.projectStateService.getProjectId()}`).subscribe((status) => {
            this.currentProjectMigrationState = status;
        });
    }

    public sendAcknowledgeToBackend(): void {
        this.http.put<void>(`/api/project/migrated/${this.currentProjectMigrationState.migratedId}/acknowledged`, {}).subscribe();
    }
}
